// Lightweight activity tracking — fire-and-forget page view events
import { authFetch } from "./fetch";
import { API_BASE } from "./utils";

let lastTrackedPath = "";

/** Track a page view. Call from useEffect on location change. */
export function trackPageView(path: string, token: string | undefined): void {
  // Dedupe — don't re-track the same path
  const normalized = path.split("?")[0];
  if (normalized === lastTrackedPath) return;
  lastTrackedPath = normalized;

  if (!token) return;

  authFetch(`${API_BASE}/v1/activity/page`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ page: normalized })
  }, token).catch(() => { /* best-effort */ });
}
